import { useCommonTranslations } from '@creativegs/pipe-toolkit/utils/translation'
import LoginSVG from '../assets/svgs/LoginSVG'

const LoginLink: React.FC = () => {
  const { t } = useCommonTranslations()

  return (
    <a
      href={process.env.NEXT_PUBLIC_APP_URL}
      className="flex items-center maxWidth z-10 no-underline group text-gold-100 hover:text-gold-200 font-bold h-6"
    >
      <LoginSVG />
      {t('login')}
    </a>
  )
}

export default LoginLink
